export const MODAL_TYPE_INSTORE_HIW = 'mt_instoreHiw';
export const MODAL_TYPE_INSTORE_OFFER = 'mt_instoreOffer';
export const MODAL_TYPE_NEAR_ME_MAP = 'mt_allStoresMap';
export const MODAL_TYPE_INSTORE_MANAGE_CARDS = 'mt_instoreManageCards';
export const MODAL_TYPE_INSTORE_ADD_NEW_CARD = 'mt_instoreAddNewCard';
export const MODAL_TYPE_INSTORE_SMS_NUMBER = 'mt_instoreSMSNumber';
export const MODAL_TYPE_INSTORE_MULTI_LINK = 'mt_instoreMultiLink';
export const MODAL_TYPE_ONBOARDING = 'mt_onboarding';
